import styles from "./Error.module.scss";

export type ErrorProps = {
  readonly children: string;
  readonly id: string;
};

export const Error = ({ children, id }: ErrorProps): JSX.Element => (
  <span className={styles.error} id={id}>
    {children}
  </span>
);
